import { Component, ViewChild, Input, Renderer2, ElementRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProductVariant } from '../../../shared/interfaces/wheels';
import { Subscription } from 'rxjs';
import { ApiServices } from '../../../shared/services/api.service';
import { CartModel } from '../../../shared/models/cart.model';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../../shared/services/data.service';
import { HelperService } from '../../../shared/services/helper.service';
import * as $ from 'jquery';
import { Product } from '../../../shared/interfaces/wheels';

// Import new services
import { WheelCartService, CartItem } from '../../../shared/services/wheel-cart.service';
import { WheelPricingService } from '../../../shared/services/wheel-pricing.service';
import { WheelRouteDetectionService, RouteInfo } from '../../../shared/services/wheel-route-detection.service';

@Component({
  selector: 'app-wheel-detail-modal-refactored',
  templateUrl: './wheel-detail-modal-refactored.component.html',
  styleUrls: ['./wheel-detail-modal-refactored.component.scss']
})
export class WheelDetailModalRefactoredComponent implements OnInit, OnChanges {

  @Input() modal: NgbModal;
  @Input() checkfitment = false;
  @Input() vehicle: any;
  @Input() is_hide_cost;
  @Input() product: ProductVariant;
  @Input() vehicleWheels: [ProductVariant];
  @Input() deliveryDate: any;
  @ViewChild('detailpagemodal') detailpagemodal;

  // Core state management
  routeInfo: RouteInfo;
  isSearchBySize = false;
  cartItems: CartItem[] = [];
  totalPrice = 0;
  
  // Legacy state (maintained for compatibility)
  productAddedToCart: any = null;
  cartProcessing = false;
  isLoggedIn = false;
  cartResp: any = null;
  isProductCustomization = false;
  showAddOn = 0;
  addToCartPopup: NgbModalRef;
  prodAddons = [];
  twoCustomizations = false;
  showFirstButton = true;
  showSecondButton = true;

  // Subscriptions
  searchVehicleSub: Subscription;
  cartSubscription: Subscription;
  loginSubscription: Subscription;
  closeResult: string;
  // Product customization properties
  custom_finish: string = '';
  custom_finish_price: string = '';
  bolt_pattern: string = 'recommended';
  offset: string = 'recommended';
  pc_cost_per_wheel: string = '';
  vehicle_year_make_model: string = '';
  p_customization_submitted: boolean = false;
  custom_binders: any[] = [];
  offsetDropdownValues: number[] = [];

  constructor(
    private apiService: ApiServices,
    private toastr: ToastrService,
    private router: Router,
    private dataService: DataService,
    private helperService: HelperService,
    private modalService: NgbModal,
    private _renderer2: Renderer2,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    // New services
    private wheelCartService: WheelCartService,
    private wheelPricingService: WheelPricingService,
    private wheelRouteDetectionService: WheelRouteDetectionService
  ) { }

  ngOnInit(): void {
    this.loginSubscription = this.dataService.isLoggedIn.asObservable().subscribe(loggedIn => this.isLoggedIn = loggedIn);
    this.detectRouteInfo();
    this.initializeProductAddedToCart();
    // Debug: Log initial product and vehicleWheels
    console.log('[WheelDetailModal] ngOnInit - product:', this.product);
    console.log('[WheelDetailModal] ngOnInit - vehicleWheels:', this.vehicleWheels);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product) {
      this.initializeProductAddedToCart();
      // Debug: Log product change
      console.log('[WheelDetailModal] ngOnChanges - product changed:', changes.product.currentValue);
    }
    if (changes.vehicleWheels) {
      // Debug: Log vehicleWheels change
      console.log('[WheelDetailModal] ngOnChanges - vehicleWheels changed:', changes.vehicleWheels.currentValue);
    }
  }

  /**
   * Detects route information and search type
   */
  private detectRouteInfo(): void {
    this.routeInfo = this.wheelRouteDetectionService.detectRouteInfo(this.route, this.route.snapshot.queryParams);
    this.isSearchBySize = this.routeInfo.isSearchBySize;
  }

  /**
   * Initialize productAddedToCart to prevent null reference errors
   */
  private initializeProductAddedToCart(): void {
    if (this.product && !this.productAddedToCart) {
      this.productAddedToCart = this.product;
    }
  }

  /**
   * Handles fitment check from child component
   */
  handleFitmentCheck(fitmentData: any): void {
    // Implementation for fitment check
    // This would typically make an API call to check fitment
    console.log('[WheelDetailModal] handleFitmentCheck - fitmentData:', fitmentData);
    // Debug: Log current vehicleWheels after fitment check
    console.log('[WheelDetailModal] handleFitmentCheck - vehicleWheels:', this.vehicleWheels);
  }  /**
   * Handles cart items change from size selection components
   */
  handleCartItemsChange(items: CartItem[]): void {
    this.cartItems = items;
    // Debug: Log cart items change
    console.log('[WheelDetailModal] handleCartItemsChange - cartItems:', items);
    // Clear previous customization data to force refresh
    this.resetCustomizationData();
    
    // When cart items change, immediately get cart preview for customization options
    if (this.cartItems.length > 0) {
      this.getCartPreviewForCustomization();
    } else {
      // No items selected, hide customization
      this.isProductCustomization = false;
    }
  }

  /**
   * Reset customization data when wheel selection changes
   */
  private resetCustomizationData(): void {
    this.cartResp = null;
    this.isProductCustomization = false;
    this.custom_binders = [];
    this.custom_finish = '';
    this.custom_finish_price = '';
    this.bolt_pattern = 'recommended';
    this.offset = 'recommended';
    this.vehicle_year_make_model = '';
    this.p_customization_submitted = false;
      console.log('🔄 Customization data reset for new wheel selection');
  }

  /**
   * Handles price change from size selection components
   */
  handlePriceChange(price: number): void {
    this.totalPrice = price;
  }

  /**
   * Gets cart preview to check for customization options
   */
  private getCartPreviewForCustomization(): void {
    const sessionId = localStorage.getItem('session_id') || '';
    const cartData = this.wheelCartService.prepareCartData(this.cartItems, sessionId);

    console.log('🔧 Getting cart preview for customization with cart data:', cartData);

    // Call add to cart to get preview data (this won't actually add to cart, just returns customization options)
    this.apiService.addToCart(cartData).subscribe(
      response => {
        if (response.status && response.data) {
          this.cartResp = response.data;
          this.productAddedToCart = this.product;
            console.log('🔧 Cart preview response for customization:', this.cartResp);
          
          // Check if customization is needed
          if (this.cartResp?.product_customizations) {
            this.handleProductCustomization();
            
            // ✅ FIXED: Generate offset dropdown for each selected wheel variant
            this.cartItems.forEach((cartItem, index) => {
              const wheelVariantId = cartItem.product_variant_id?.toString();
              const customizationData = this.cartResp.product_customizations[wheelVariantId];
              
              console.log(`🔧 Checking customization for wheel ${index + 1} (${wheelVariantId}):`, {
                customizationData: customizationData,
                is_offset_drilling: customizationData?.is_offset_drilling
              });
              
              if (customizationData?.is_offset_drilling) {
                // Get the actual wheel data to find the offset
                const wheelData = this.getWheelDataForPosition(index);
                if (wheelData?.offset) {
                  console.log(`🔧 Generating offset dropdown for wheel ${index + 1} (${wheelVariantId}):`, wheelData.offset);
                  this.generateOffsetDropdownValues(wheelData.offset);                } else {
                  console.warn(`⚠️ No offset data found for wheel ${index + 1} (${wheelVariantId})`);
                }
              }
            });
            
            // Also check for any wheel that has offset drilling - ensure offset dropdown is generated
            const customizationKeys = Object.keys(this.cartResp.product_customizations);
            for (const key of customizationKeys) {
              const productCustomization = this.cartResp.product_customizations[key];
              if (productCustomization.is_offset_drilling) {
                // Find any wheel with this variant ID to get offset data
                const associatedWheel = this.vehicleWheels?.find(w => w.id.toString() === key);
                if (associatedWheel?.offset && this.offsetDropdownValues.length === 0) {
                  console.log(`🔧 Generating offset dropdown from vehicle wheels for key ${key}:`, associatedWheel.offset);
                  this.generateOffsetDropdownValues(associatedWheel.offset);
                  break;
                }
              }
            }          } else {
            console.log('⚠️ No customization data available:', response);
            this.cartResp = null;
            this.isProductCustomization = false;
          }
        } else {
          console.log('⚠️ No cart preview data received:', response);
          this.cartResp = null;
          this.isProductCustomization = false;
        }
      },
      error => {
        console.error('❌ Error getting cart preview for customization:', error);
        this.cartResp = null;
        this.isProductCustomization = false;
      }
    );
  }


  /**
   * Handles successful cart addition
   */
  private handleSuccessfulCartAddition(response: any): void {
    this.productAddedToCart = this.product;
    this.cartResp = response.data;

    // Google Analytics tracking
    this.trackAddToCartEvent();    // Get product add-ons
    if (this.cartItems.length > 0) {
      const productId = typeof this.cartItems[0].product_id === 'string' 
        ? parseInt(this.cartItems[0].product_id, 10) 
        : this.cartItems[0].product_id;
      
      this.apiService.getAddsOnByProduct(productId).subscribe(
        response => {
          if (response.status) {
            this.prodAddons = response.data;
          }
        },
        error => { }
      );
    }

    // Handle product customization only if not already initialized
    if (!this.isProductCustomization && this.cartResp?.product_customizations) {
      this.handleProductCustomization();
    }
  }

  /**
   * Tracks add to cart event for Google Analytics
   */
  private trackAddToCartEvent(): void {
    const totalItems = this.cartItems.length;
    let script = this._renderer2.createElement('script');
    script.type = 'text/javascript';
    script.id = 'gtagId';
    script.text = `
    dataLayer.push({
      'event': 'addToCart',
      'ecommerce': {
        'currencyCode': '$',
        'add': {
          'products': [`;

    this.cartItems.forEach((value, key) => {
      script.text += `{
        'id': '${value.product_id}',
        'variant': '${value.product_variant_id}',
        'quantity': '${value.quantity}',
        'type': '${value.type}',
        'category': 'Alloy Wheel'
      }`;
      if ((key + 1) !== totalItems) {
        script.text += `,`;
      }
    });

    script.text += `]
        }
      }
    });
    `;
    $("#googleTagManagerScript").before(script);
  }  /**
   * Handles product customization logic
   */
  private handleProductCustomization(): void {
    if (!this.cartResp?.product_customizations) {
      this.isProductCustomization = false;
      return;
    }

    const firstKey = this.getFirstKey(this.cartResp.product_customizations);
    const productCustomization = this.cartResp.product_customizations[firstKey];
    
    console.log('🎨 Processing product customization:', {
      firstKey: firstKey,
      productCustomization: productCustomization,
      total_customizations: Object.keys(this.cartResp.product_customizations).length
    });
    
    const isCustomFinish = productCustomization.is_custom_finish;
    const isBoltPatterns = productCustomization.bolt_patterns;
    const isOffsetDrilling = productCustomization.is_offset_drilling;
    
    // Show customization if ANY customization option is available
    if (isCustomFinish || (isBoltPatterns && isBoltPatterns.length > 0) || isOffsetDrilling) {
      this.isProductCustomization = true;
      
      // Initialize custom_binders for each customization
      this.initializeCustomBinders();
      
      console.log('✅ Product customization enabled with binders:', this.custom_binders);
      
    } else {
      this.isProductCustomization = false;
      console.log('❌ No valid customization options found');
    }

    this.pc_cost_per_wheel = productCustomization.pc_cost_per_wheel ? productCustomization.pc_cost_per_wheel : '';
    
    if (this.cartResp.product_customizations && Object.keys(this.cartResp.product_customizations).length > 1) {
      this.twoCustomizations = true;
    } else {
      this.goToSecondPopup();
    }
  }
  /**
   * Initialize custom binders for each customization
   */
  private initializeCustomBinders(): void {
    if (!this.cartResp?.product_customizations) {
      return;
    }

    console.log('🔧 Initializing custom binders with cart items:', this.cartItems);
    console.log('🔧 Available customizations:', Object.keys(this.cartResp.product_customizations));
    
    this.custom_binders = [];

    // For search-by-size mode, create binders based on cart items
    if (this.isSearchBySize && this.cartItems && this.cartItems.length > 0) {
      this.cartItems.forEach((cartItem, index) => {
        const wheelVariantId = cartItem.product_variant_id.toString();
        const customizationData = this.cartResp.product_customizations[wheelVariantId];
        
        if (customizationData) {
          this.custom_binders.push({
            custom_finish_id: wheelVariantId,
            customization_key: wheelVariantId,
            custom_finish: "",
            custom_finish_price: '', // Add price tracking per wheel
            bolt_pattern: "recommended",
            offset: "recommended",
            vehicle_year_make_model: '',
            wheel_index: index,
            wheel_type: cartItem.type // front or rear
          });
          
          console.log(`🔧 Created binder for ${cartItem.type} wheel (variant ${wheelVariantId})`, {
            has_custom_finish: !!customizationData.is_custom_finish,
            has_bolt_patterns: !!customizationData.bolt_patterns?.length
          });
        }
      });
    } else {
      // Fallback to legacy approach for regular search
      const customizationKeys = Object.keys(this.cartResp.product_customizations);
      customizationKeys.forEach((customizationKey, index) => {
        this.custom_binders.push({
          custom_finish_id: customizationKey,
          customization_key: customizationKey,
          custom_finish: "",
          custom_finish_price: '', // Add price tracking per wheel
          bolt_pattern: "recommended",
          offset: "recommended",
          vehicle_year_make_model: '',
          wheel_index: index
        });
      });
    }
    
    console.log('🔧 Initialized custom_binders:', this.custom_binders);
  }
  /**
   * Handles validation errors from cart manager
   */
  handleValidationError(errorMessage: string): void {
    // Error is already shown by cart manager component
  }

  /**
   * Closes the modal
   */
  closeModal = (): void => {
    this.modal.dismissAll();
  }

  /**
   * Closes modal and redirects to cart
   */  closeModalAndRedirectCart = (): void => {
    this.addToCartFromProductCustomizationPopup(this.cartResp, true);
    this.modal.dismissAll();
    this.router.navigateByUrl('/cart');
  }
  // Legacy methods (maintained for compatibility)
  getFirstKey(obj: any): string {
    if (!obj) return '';
    return Object.keys(obj)[0] || '';
  }

  getSecondKey(obj: any): string {
    if (!obj) return '';
    return Object.keys(obj)[1] || '';
  }

  getFirstQuantity(): number {
    return 2; // Default quantity for front wheels
  }

  getSecondQuantity(): number {
    return 2; // Default quantity for rear wheels
  }

  returnSize(wheelIndex: number): string {
    if (!this.cartResp?.product_customizations) return '';
    
    const keys = Object.keys(this.cartResp.product_customizations);
    const key = wheelIndex === 1 ? keys[0] : keys[1];
    
    if (key && this.cartResp.product_customizations[key]) {
      // Try to get size from customization data or fallback to product
      return this.cartResp.product_customizations[key].size || 
             this.productAddedToCart?.size || 
             this.product?.size || 
             'N/A';
    }
    
    return this.productAddedToCart?.size || this.product?.size || 'N/A';
  }

  stringifyImages(images: any): string {
    if (Array.isArray(images)) {
      return images[0] || '';
    }
    if (typeof images === 'string') {
      try {
        const parsed = JSON.parse(images);
        return Array.isArray(parsed) ? parsed[0] || '' : images;
      } catch {
        return images;
      }
    }
    return '';
  }
  /**
   * Check if customization is complete for add to cart
   */
  isCustomizationComplete(): boolean {
    if (!this.isProductCustomization || !this.custom_binders.length) {
      return true;
    }

    return this.custom_binders.every(binder => {
      // Custom finish is required if available
      const customFinishValid = !this.isCustomFinishRequired(binder) || (binder.custom_finish && binder.custom_finish !== '');
      
      // Bolt pattern is valid if recommended or a value is selected
      const boltPatternValid = binder.bolt_pattern && binder.bolt_pattern !== '';
      
      // Offset is valid if recommended or a value is selected  
      const offsetValid = binder.offset && binder.offset !== '';
      
      // Vehicle year make model is always required
      const vehicleValid = binder.vehicle_year_make_model && binder.vehicle_year_make_model.trim() !== '';
      
      return customFinishValid && boltPatternValid && offsetValid && vehicleValid;
    });
  }

  /**
   * Check if custom finish is required for a specific binder
   */
  private isCustomFinishRequired(binder: any): boolean {
    if (!this.cartResp?.product_customizations || !binder.customization_key) {
      return false;
    }
    
    const customization = this.cartResp.product_customizations[binder.customization_key];
    return customization?.is_custom_finish === true;
  }
  /**
   * Get specific validation messages for missing fields
   */
  getValidationMessages(): string[] {
    const messages: string[] = [];
    
    if (!this.isProductCustomization || !this.custom_binders.length) {
      return messages;
    }

    this.custom_binders.forEach((binder, index) => {
      const wheelLabel = this.twoCustomizations ? 
        (index === 0 ? 'Front Wheel' : 'Rear Wheel') : 
        'Wheel';

      // Check if custom finish is required and missing
      if (this.isCustomFinishRequired(binder) && (!binder.custom_finish || binder.custom_finish === '')) {
        messages.push(`${wheelLabel}: Please select a Custom Finish`);
      }
      
      // Check bolt pattern
      if (!binder.bolt_pattern || binder.bolt_pattern === '') {
        messages.push(`${wheelLabel}: Please select a Bolt Pattern`);
      }
      
      // Check offset
      if (!binder.offset || binder.offset === '') {
        messages.push(`${wheelLabel}: Please select an Offset`);
      }
      
      // Vehicle year make model is always required
      if (!binder.vehicle_year_make_model || binder.vehicle_year_make_model.trim() === '') {
        messages.push(`${wheelLabel}: Please enter Vehicle Year Make Model for fitment`);
      }
    });

    return messages;
  }

  goToSecondPopup(): void {
    // Implementation for second popup
  }

  addToCartFromProductCustomizationPopup(custObj: any, fromFirstPopup: boolean): void {
    const product = this.productAddedToCart;
    this.p_customization_submitted = true;
    
    if (this.offsetDropdownValues.length == 0) {
      this.offset = '';
    }
    if ((custObj.bolt_patterns && custObj.bolt_patterns.length == 0) || (!custObj.bolt_patterns)) {
      this.bolt_pattern = '';
    }
    if ((this.bolt_pattern == 'recommended' || this.offset == 'recommended') && !this.vehicle_year_make_model) {
      return;
    }    if ((custObj.is_custom_finish && this.custom_finish) || (!custObj.is_custom_finish && !this.custom_finish)) {
      const session_id = localStorage.getItem('session_id');
      const product_id = product.product_id;
      let product_variant_id: string;
      
      if (fromFirstPopup) {
        product_variant_id = Object.keys(this.cartResp?.product_customizations)[0];
      } else {
        product_variant_id = Object.keys(this.cartResp?.product_customizations).length > 1 
          ? Object.keys(this.cartResp.product_customizations)[1] 
          : Object.keys(this.cartResp.product_customizations)[0];
      }
      
      const data = {
        session_id,
        product_id,
        product_variant_id,
        type: "pc_updated_to_cart_directly",
        custom_finish: this.custom_finish,
        custom_finish_price: this.custom_finish_price,
        bolt_pattern: this.bolt_pattern,
        offset: this.offset,
        cost_per_wheel: this.pc_cost_per_wheel,
        vehicle_year_make_model: this.vehicle_year_make_model
      };
      
      this.cartProcessing = true;
      this.cartSubscription = this.apiService.addToCart(data).subscribe(
        response => {
          this.cartProcessing = false;
          if (response.status) {
            // Update cart data
            this.apiService.getCart().subscribe(response => {
              if (response.status) {
                this.dataService.setCartData(response);
              }
            });
              // Get product add-ons
            const productId = typeof this.cartItems[0].product_id === 'string' 
              ? parseInt(this.cartItems[0].product_id, 10) 
              : this.cartItems[0].product_id;
            this.apiService.getAddsOnByProduct(productId).subscribe(
              response => {
                if (response.status) {
                  this.prodAddons = response.data;
                }
              },
              error => {}
            );
            
            if (!fromFirstPopup) {
              this.showSecondButton = false;
            } else {
              this.showFirstButton = false;
            }

            this.resetProdCustomizationProperties();
            
            if (fromFirstPopup) {
              const productcustomization = this.cartResp.product_customizations[this.getSecondKey(this.cartResp.product_customizations)];
              this.pc_cost_per_wheel = productcustomization.pc_cost_per_wheel ? productcustomization.pc_cost_per_wheel : '';
            }
            
            this.toastr.success(response.message, 'Success');
          }
        }, 
        error => {
          this.cartProcessing = false;
          this.toastr.error(error.error.message, 'Error');
        }
      );
    }
  }

  onCustomFinishSelect(event: any, customizationObj: any): void {
    const custom_finish = customizationObj.product_customizations.find(x => x.id == event.target.value);
    if (custom_finish) {
      this.custom_finish_price = custom_finish.cost;
    }
  }

  resetProdCustomizationProperties(fromHTML: boolean = false): void {
    this.custom_finish = '';
    this.custom_finish_price = '';
    this.bolt_pattern = 'recommended';
    this.offset = 'recommended';
    this.pc_cost_per_wheel = '';
    this.vehicle_year_make_model = '';
    this.p_customization_submitted = false;
    if (fromHTML) {
      this.closeModal();
    }
  }

  addToWishlist(productId: any): void {
    // Implementation for wishlist functionality
  }
  openModal(content: any): void {
    this.addToCartPopup = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true });
    this.addToCartPopup.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  /**
   * Handles add to cart event from cart manager component
   */
  handleAddToCart(cartData: any): void {
    this.cartProcessing = true;
    
    this.apiService.addToCart(cartData).subscribe(
      response => {
        this.cartProcessing = false;
        if (response.status) {
          this.handleSuccessfulCartAddition(response);
          this.showPostCartSuccessFlow();
        }
      },
      error => {
        this.cartProcessing = false;
        this.toastr.error(error.error?.message || 'Failed to add to cart', 'Error');
      }
    );
  }  /**
   * Shows the appropriate flow after successful cart addition
   */
  private showPostCartSuccessFlow(): void {
    // Check if product has add-ons to show
    if (this.prodAddons && this.prodAddons.length > 0) {
      this.showAddOn = 1;
      
      // Trigger add-on modal after a short delay
      setTimeout(() => {
        const element: HTMLElement = document.getElementById('auto_trigger_list') as HTMLElement;
        if (element) {
          element.click();
        }
      }, 1000);
    } else {
      this.closeModalAndRedirectToCart();
    }
  }

  /**
   * Closes the modal and redirects to cart page
   */
  private closeModalAndRedirectToCart(): void {
    if (this.modal && this.modal.dismissAll) {
      this.modal.dismissAll();
    }
    this.router.navigateByUrl('/cart');
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {    return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }  /**
   * Handle custom finish selection with proper wheel index support
   */
  handleCustomFinishSelect(event: any, wheelIndex: number = 0): void {
    const selectedId = parseInt(event?.target?.value);
    console.log('🔧 Custom finish selection started:', {
      wheel_index: wheelIndex,
      selected_id: selectedId,
      event_value: event?.target?.value,
      custom_binders_available: this.custom_binders?.length || 0
    });
    
    if (!selectedId || !this.custom_binders[wheelIndex]) {
      // Reset custom finish if no selection
      if (this.custom_binders[wheelIndex]) {
        this.custom_binders[wheelIndex].custom_finish_price = '';
        this.custom_binders[wheelIndex].custom_finish = '';
        console.log('⚠️ Custom finish cleared for wheel', wheelIndex + 1);
      }
      return;
    }

    // Update the custom finish for the specific wheel
    this.custom_binders[wheelIndex].custom_finish = selectedId;
    
    // Get the customization data for this wheel position
    const customizationData = this.getCustomizationForWheelPosition(wheelIndex);
    
    if (customizationData && customizationData.product_customizations) {
      const selectedCustomization = customizationData.product_customizations.find(
        (pc: any) => pc.id === selectedId
      );
      
      if (selectedCustomization) {
        // ✅ FIXED: Store price per wheel instead of globally
        this.custom_binders[wheelIndex].custom_finish_price = selectedCustomization.cost || '';
        
        // Also update global for backwards compatibility with legacy code
        this.custom_finish_price = selectedCustomization.cost || '';
        
        console.log('✅ Custom finish selected for wheel', wheelIndex + 1, ':', {
          wheel_index: wheelIndex,
          selected_id: selectedId,
          finish_name: selectedCustomization.finish_name,
          cost: selectedCustomization.cost,
          stored_in_binder: this.custom_binders[wheelIndex].custom_finish_price,
          wheel_variant_id: this.getWheelVariantId(wheelIndex),
          custom_binders_state: this.custom_binders.map((binder, index) => ({
            index,
            custom_finish: binder.custom_finish,
            custom_finish_price: binder.custom_finish_price
          }))
        });
      } else {
        console.error('❌ Selected customization not found:', {
          selectedId,
          available_customizations: customizationData.product_customizations.map((pc: any) => ({
            id: pc.id,
            finish_name: pc.finish_name,
            cost: pc.cost
          }))
        });
      }
    } else {
      console.error('❌ No customization data found for wheel position:', {
        wheelIndex,
        customizationData: customizationData,
        cartResp: this.cartResp?.product_customizations ? Object.keys(this.cartResp.product_customizations) : 'No customizations'
      });
    }
  }
  /**
   * Handle add to cart from customization component
   */
  handleCustomizationAddToCart(): void {
    this.p_customization_submitted = true;
    
    // Validate that all required customization fields are filled
    if (!this.isCustomizationComplete()) {
      this.toastr.error("Please complete all customization options", "Validation Error");
      return;
    }

    // Process each customization binder
    this.custom_binders.forEach((binder, index) => {
      const customizationKey = binder.customization_key;
      const customizationObj = this.cartResp.product_customizations[customizationKey];
      
      if (customizationObj) {
        this.addSingleWheelCustomizationToCart(binder, customizationObj, index === 0);
      }
    });
  }  /**
   * Add a single wheel customization to cart
   */
  private addSingleWheelCustomizationToCart(binder: any, customizationObj: any, isFirst: boolean): void {
    const sessionId = localStorage.getItem('session_id');
    const productId = this.productAddedToCart.product_id;
    const productVariantId = binder.customization_key;
    
    // ✅ FIXED: Use per-wheel custom finish price instead of global
    const customFinishPrice = binder.custom_finish_price || this.custom_finish_price || '';
    
    const data = {
      session_id: sessionId,
      product_id: productId,
      product_variant_id: productVariantId,
      type: "pc_updated_to_cart_directly",
      custom_finish: binder.custom_finish,
      custom_finish_price: customFinishPrice,
      bolt_pattern: binder.bolt_pattern,
      offset: binder.offset,
      cost_per_wheel: this.pc_cost_per_wheel,
      vehicle_year_make_model: binder.vehicle_year_make_model
    };
    
    console.log('🛒 Adding wheel customization to cart:', {
      wheel_index: binder.wheel_index,
      wheel_type: binder.wheel_type || 'unknown',
      product_variant_id: productVariantId,
      custom_finish: binder.custom_finish,
      custom_finish_price: customFinishPrice,
      binder_price: binder.custom_finish_price,
      global_price: this.custom_finish_price,
      cart_data: data,
      all_binders_state: this.custom_binders.map((b, i) => ({
        index: i,
        custom_finish: b.custom_finish,
        custom_finish_price: b.custom_finish_price,
        customization_key: b.customization_key
      }))
    });
    
    this.cartProcessing = true;
    this.apiService.addToCart(data).subscribe(
      response => {
        this.cartProcessing = false;
        console.log('✅ Cart addition response:', response);
        
        if (response.status) {
          // Update cart data
          this.apiService.getCart().subscribe(cartResponse => {
            if (cartResponse.status) {
              this.dataService.setCartData(cartResponse);
              console.log('🔄 Cart data updated after customization');
            }
          });
          
          // Close modal and show success
          this.toastr.success(response.message, 'Success');
          this.closeModalAndRedirectToCart();
        } else {
          console.error('❌ Cart addition failed:', response);
          this.toastr.error(response.message || 'Failed to add to cart', 'Error');
        }
      },
      error => {
        this.cartProcessing = false;
        console.error('❌ Cart addition error:', error);
        this.toastr.error(error.error?.message || 'Failed to add customization to cart', 'Error');
      }
    );
  }

  /**
   * Check validation and submit for customization
   */  checkValidAndSubmit(): boolean {
    let isValid = true;
    let missingFields: string[] = [];
    
    this.custom_binders.forEach((binder, index) => {
      if (binder.custom_finish == '' || binder.custom_finish == null) {
        isValid = false;
        missingFields.push(`Custom finish for wheel ${index + 1}`);
      }
      if (binder.offset == '' || binder.offset == null) {
        isValid = false;
        missingFields.push(`Offset for wheel ${index + 1}`);
      }
      if (binder.bolt_pattern == '' || binder.bolt_pattern == null) {
        isValid = false;
        missingFields.push(`Bolt pattern for wheel ${index + 1}`);
      }
      if (binder.vehicle_year_make_model == '' || binder.vehicle_year_make_model == null) {
        isValid = false;
        missingFields.push(`Vehicle details for wheel ${index + 1}`);
      }
    });

    console.log("Custom Binder", this.custom_binders);
    
    if (!isValid) {
      const errorMessage = `Please choose the following customization options:\n• ${missingFields.join('\n• ')}`;
      alert(errorMessage);
      this.p_customization_submitted = true;
      return false;
    }
      // If validation passes, proceed with customization cart submission
    this.addToCartFromProductCustomizationPopup(this.cartResp, true);
    return true;
  }

  /**
   * Generate offset dropdown values
   */
  generateOffsetDropdownValues(offset: string): void {
    this.offsetDropdownValues = [];
    
    if (!offset) {
      return;
    }

    console.log('Generating offset dropdown for:', offset);
    
    // Clean the offset string - remove units like 'mm'
    const cleanOffset = offset.replace(/mm|in|cm/gi, '').trim();
    
    // Handle range patterns: "-4 to 42", "-4-42", "-4/42", etc.
    const rangeMatch = cleanOffset.match(/^(-?\d+\.?\d*)\s*(?:to|-|\/)\s*(-?\d+\.?\d*)$/);
    
    if (rangeMatch) {
      // Range pattern found
      const start = parseFloat(rangeMatch[1]);
      const end = parseFloat(rangeMatch[2]);
      
      if (!isNaN(start) && !isNaN(end)) {
        console.log(`Generating range from ${start} to ${end}`);
        
        // Generate all integer values in the range
        for (let i = start; i <= end; i++) {
          this.offsetDropdownValues.push(i);
        }
      }
    } else {
      // Try to parse as single value or multiple discrete values
      const parts = cleanOffset.split(/[,\s]+/).filter(part => part.trim() !== '');
      
      parts.forEach(part => {
        const value = parseFloat(part.trim());
        if (!isNaN(value)) {
          this.offsetDropdownValues.push(value);
        }
      });
    }
    
    // Remove duplicates and sort
    this.offsetDropdownValues = [...new Set(this.offsetDropdownValues)];
    this.offsetDropdownValues.sort((a, b) => a - b);
    
    console.log('Generated offset values:', this.offsetDropdownValues);
  }

  ngOnDestroy(): void {
    if (this.searchVehicleSub) {
      this.searchVehicleSub.unsubscribe();
    }
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
  }

  /**
   * Gets customization data for a specific wheel position (0 = front, 1 = rear)
   * This dynamically maps to the correct wheel variant based on cart items
   */
  getCustomizationForWheelPosition(wheelPosition: number): any {
    if (!this.cartResp?.product_customizations || !this.cartItems[wheelPosition]) {
      return null;
    }

    // In search-by-size mode, use the selected wheel variant ID as the key
    if (this.isSearchBySize && this.cartItems[wheelPosition]) {
      const wheelVariantId = this.cartItems[wheelPosition].product_variant_id;
      const customizationData = this.cartResp.product_customizations[wheelVariantId];
      
      console.log(`🔧 Getting customization for wheel position ${wheelPosition}:`, {
        wheelVariantId,
        customizationData,
        has_custom_finish: !!customizationData?.is_custom_finish,
        has_bolt_patterns: !!customizationData?.bolt_patterns?.length
      });
      
      return customizationData;
    }

    // Fallback to legacy approach for regular search
    const keys = Object.keys(this.cartResp.product_customizations);
    const key = keys[wheelPosition];
    return key ? this.cartResp.product_customizations[key] : null;
  }

  /**
   * Gets the wheel variant ID for a specific position
   */
  getWheelVariantId(wheelPosition: number): string {
    if (this.cartItems && this.cartItems[wheelPosition]) {
      return this.cartItems[wheelPosition].product_variant_id?.toString() || '';
    }
    return '';
  }

  /**
   * Checks if a wheel position has customization data available
   */
  hasCustomizationForPosition(wheelPosition: number): boolean {
    const customization = this.getCustomizationForWheelPosition(wheelPosition);
    return !!(customization && (
      customization.is_custom_finish || 
      (customization.bolt_patterns && customization.bolt_patterns.length > 0) ||
      customization.is_offset_drilling
    ));
  }

  /**
   * Gets the selected wheel data for a specific position (0 = front, 1 = rear)
   */
  getSelectedWheelForPosition(wheelPosition: number): ProductVariant | null {
    if (!this.cartItems || !this.cartItems[wheelPosition]) {
      return null;
    }

    const cartItem = this.cartItems[wheelPosition];
    const wheelVariantId = cartItem.product_variant_id;
    
    // Find the wheel in vehicleWheels array
    if (this.vehicleWheels) {
      const selectedWheel = this.vehicleWheels.find(w => w.id == wheelVariantId);
      if (selectedWheel) {
        console.log(`🔧 Found wheel data for position ${wheelPosition}:`, {
          wheelVariantId,
          size: selectedWheel.size,
          sku: selectedWheel.sku,
          bolt_pattern: selectedWheel.bolt_pattern,
          offset: selectedWheel.offset
        });
        return selectedWheel;
      }
    }

    return null;
  }

  /**
   * Gets the quantity for a specific wheel position
   */
  getQuantityForPosition(wheelPosition: number): number {
    if (!this.cartItems || !this.cartItems[wheelPosition]) {
      return 2; // Default quantity
    }
    return this.cartItems[wheelPosition].quantity || 2;
  }

  /**
   * Gets the size display text for a specific wheel position
   */
  getSizeForPosition(wheelPosition: number): string {
    const wheel = this.getSelectedWheelForPosition(wheelPosition);
    if (wheel) {
      return wheel.size || `${wheel.rim_diameter}x${wheel.rim_width}` || 'N/A';
    }
    return this.product?.size || 'N/A';
  }

  /**
   * Gets the SKU for a specific wheel position
   */
  getSkuForPosition(wheelPosition: number): string {
    const wheel = this.getSelectedWheelForPosition(wheelPosition);
    return wheel?.sku || this.product?.sku || 'N/A';
  }

  /**
   * Gets the bolt pattern for a specific wheel position
   */
  getBoltPatternForPosition(wheelPosition: number): string {
    const wheel = this.getSelectedWheelForPosition(wheelPosition);
    return wheel?.bolt_pattern || this.product?.bolt_pattern || 'N/A';
  }

  /**
   * Gets the offset for a specific wheel position
   */
  getOffsetForPosition(wheelPosition: number): string {
    const wheel = this.getSelectedWheelForPosition(wheelPosition);
    return wheel?.offset || this.product?.offset || 'N/A';
  }  /**
   * Gets the price for a specific wheel position
   */
  getPriceForPosition(wheelPosition: number): number {
    // ✅ ENHANCED: Better wheel pricing logic with multiple fallbacks
    const wheel = this.getSelectedWheelForPosition(wheelPosition);
    if (wheel) {
      // ✅ FIXED: Use the pricing priority order from wheel selector
      const unitPrice = wheel.uae_retail_price || wheel.us_retail_price || wheel.price || 0;
      console.log(`💰 Price for wheel position ${wheelPosition}:`, {
        wheelVariantId: wheel.id,
        sku: wheel.sku,
        uae_retail_price: wheel.uae_retail_price,
        us_retail_price: wheel.us_retail_price,
        price: wheel.price,
        sale_price: wheel.sale_price,
        calculated_unitPrice: unitPrice
      });
      return unitPrice;
    }
    
    // ✅ ENHANCED: Better fallback logic for when wheel is not found
    if (this.cartItems && this.cartItems[wheelPosition]) {
      // Try to find wheel data using variant ID from cart items
      const wheelVariantId = this.cartItems[wheelPosition].product_variant_id;
      console.log(`🔍 Searching for wheel with variant ID: ${wheelVariantId} in vehicleWheels array`);
      
      if (this.vehicleWheels && wheelVariantId) {
        const foundWheel = this.vehicleWheels.find(w => w.id == wheelVariantId);
        if (foundWheel) {
          const unitPrice = foundWheel.uae_retail_price || foundWheel.us_retail_price || foundWheel.price || 0;
          console.log(`✅ Found wheel pricing via cart variant ID:`, {
            wheelVariantId,
            unitPrice,
            pricing_fields: {
              uae_retail_price: foundWheel.uae_retail_price,
              us_retail_price: foundWheel.us_retail_price,
              price: foundWheel.price
            }
          });
          return unitPrice;
        }
      }
    }
    
    // ✅ FINAL: Fallback to product pricing
    const fallbackPrice = this.product?.uae_retail_price || this.product?.us_retail_price || this.product?.price || 0;
    console.log(`💰 Using fallback price for position ${wheelPosition}:`, {
      fallbackPrice,
      product_pricing: {
        uae_retail_price: this.product?.uae_retail_price,
        us_retail_price: this.product?.us_retail_price,
        price: this.product?.price
      }
    });
    return fallbackPrice;
  }

  /**
   * Gets the wheel data for a specific position (0 = front, 1 = rear)
   */
  getWheelDataForPosition(wheelPosition: number): ProductVariant | null {
    if (!this.cartItems || !this.cartItems[wheelPosition]) {
      return null;
    }

    const cartItem = this.cartItems[wheelPosition];
    const wheelVariantId = cartItem.product_variant_id;
    
    // Find the wheel in vehicleWheels array
    if (this.vehicleWheels) {
      const selectedWheel = this.vehicleWheels.find(w => w.id == wheelVariantId);
      if (selectedWheel) {
        console.log(`🔧 Found wheel data for position ${wheelPosition}:`, {
          wheelVariantId,
          size: selectedWheel.size,
          sku: selectedWheel.sku,
          bolt_pattern: selectedWheel.bolt_pattern,
          offset: selectedWheel.offset
        });
        return selectedWheel;
      }
    }

    return null;
  }
}
